const Bank = {
  bank: 'Bank',
  addBank: 'Add Bank',
  editBank: 'Edit Bank',
};
export default Bank;
